export const useTableProps = () => {};
